export const DUMMY_TEXTS = {
  INITIAL:
    "> Hey there! This is a portfolio website for Nuno Azevedo. For basic commands type cmd",
  CMD: "\n\n\xa0\xa0\xa0ls\n\xa0\xa0\xa0cat\n\xa0\xa0\xa0clear\n\xa0\xa0\xa0cmd",
  LS: "\n\n\xa0\xa0\xa0About\n\xa0\xa0\xa0Education\n\xa0\xa0\xa0Experience\n\xa0\xa0\xa0Contact_Me",
  ABOUT:
    "\n\n\xa0\xa0\xa0Always passionate about technology, I found what I really like to do, develop web pages, from layout to logic.",
  EDUCATION:
    "\n\n\xa0\xa0\xa0(2019 - 2021) Instituto Politécnico do Cávado e do Ave\n\n\xa0\xa0\xa0Technical Short Cycle Courses in Web Development and Multimedia\n\n\n\xa0\xa0\xa0(2016 - 2019) Escola Secundária Padre Benjamim Salgado\n\n\xa0\xa0\xa0Professional Course in Systems Management and Programming Technician",
  EXPERIENCE:
    "\n\n\xa0\xa0\xa0(set. 2021 - present) Frontend Developer\n\n\xa0\xa0\xa0Xpand IT\n\n\n\xa0\xa0\xa0(jul. 2019 - ago. 2021) Frontend Developer\n\n\xa0\xa0\xa0AMATECH Group\n\n\xa0\xa0\xa0Work with: React.js, Next.js, TypeScript, Redux, JS, SASS, HTML, CSS & GIT\n\n\n\xa0\xa0\xa0(mai. 2019 - jun. 2019) Frontend Developer - Intern\n\n\xa0\xa0\xa0Visual MO\n\n\xa0\xa0\xa0Work with: JS, HTML, CSS & GIT\n\n\n\xa0\xa0\xa0(jun. 2018 - jul. 2018) Frontend Developer - Intern\n\n\xa0\xa0\xa0Criativo.net - Web Design & Marketing Digital\n\n\xa0\xa0\xa0Work with: JS, HTML & CSS",
  CONTACT_ME:
    "\n\n\xa0\xa0\xa0Email - nunoazevedo295@gmail.com\n\n\xa0\xa0\xa0Linkedin - linkedin.com/in/nunoazevedo17\n\n\xa0\xa0\xa0GitHub - github.com/NunoAzevedo17",
};

export const TERMINAL_OPTIONS = {
  CMD: "cmd",
  CLEAR: "clear",
  LS: "ls",
  CAT: {
    ABOUT: "cat about",
    EDUCATION: "cat education",
    EXPERIENCE: "cat experience",
    CONTACT_ME: "cat contact_me",
  },
};

export const LS_OPTIONS = {
  ABOUT: "About",
  EDUCATION: "Education",
  EXPERIENCE: "Experience",
  CONTACT_ME: "Contact_Me",
};
